import { callGet, callPost, callPutById, callDelete } from "../integrations/calls";

import { REQ } from "../../libs/constants";

export const createItem = async (data, token) => {
  return await callPost(REQ.ITEM.ADD_ITEM, data, token);
};

export const getAllItemForUpdate = async (token) => {
  return await callGet(`${REQ.ITEM.GET_ALL_ITEM}`, token);
};

export const getLatestItemCode = async (token) => {
  return await callGet(`${REQ.ITEM.GET_LATEST_ITEM_CODE}`, token);
};

export const getItemCode = async (id, token) => {
  return await callGet(`${REQ.ITEM.GET_ITEM}/${id}`, token);
};

export const getItemRate = async (id, token) => {
  return await callGet(`${REQ.ITEM.GET_ITEM_RATE}/${id}`, token);
};

export const getRemainingItemQuantity = async (data, token) => {
  return await callPost(`${REQ.ITEM.GET_ITEM_QUANTITY}`, data, token);
};
  
export const updateSingleItem = async (data, token) => {
  return await callPutById(`${REQ.ITEM.UPDATE_ITEM}/${data.itemCode}`, data, token);
};

export const deleteSingleItem = async (data, token) => {
  return await callDelete(`${REQ.ITEM.DELETE_ITEM}/${data.itemCode}`, data, token);
};
